export class Regexes {
    public static taxnumber = "^(\\d{7})(\\d)\-([1-5])\-(0[2-9]|[13][0-9]|2[02-9]|4[0-4]|51)$";
    public static phoneNumber = "^(?:([+]\\d{1,4})[-.\\s]?)?(?:[(](\\d{1,3})[)][-.\\s]?)?(\\d{1,4})[-.\\s]?(\\d{1,4})[-.\\s]?(\\d{1,9})$";
    public static zip = "^[A-Z0-9][A-Z0-9\\s\\-]{1,8}[A-Z0-9]$";
    public static city = "^[A-z\\u00C0-\\u017F, _\\-\\./]{1,}$";
    public static address = "^[A-z0-9\\u00C0-\\u017F, _\\-\\./]{1,}$";
    public static firstNameLastName = "^[A-z\\u00C0-\\u017F, \\-\\./]{1,}$";
}
